import axios from "axios";
import CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import store from '../../store/store';
const getUrlCode = () => {
  return window.location.pathname.split('/v02/')[1]?.split('/')[0]
}
const baseURL = process.env.REACT_APP_API_ENDPOINT;
const fallBaseURL = process.env.REACT_APP_FALL_BACK_API_ENDPOINT;

const axios_v1 = axios.create({
  baseURL: baseURL,
  auth: {
    username: process.env.REACT_APP_API_USER,
    password: process.env.REACT_APP_API_PASS,
  },
});

const fall_axios_v1 = axios.create({
  baseURL: fallBaseURL,
  auth: {
    username: process.env.REACT_APP_API_USER,
    password: process.env.REACT_APP_API_PASS,
  },
});

const verifyStatus = () => {

  Promise.all([
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
    liracrypt.get("/version", {}),
  ])
    .then(([...Call1]) => {

    })
    .catch((err) => {
      console.log("Call Failed");
      liracrypt.axInstance = fall_axios_v1;
    });
};

axios_v1.interceptors.response.use(
  function (response) {
    if (response.status === 204) {
      return { ...response, data: null };
    }
    return response;
  },
  function (error) {
    // console.log(error, "Inter Error");
    // liracrypt.axInstance = fall_axios_v1;

    // verifyStatus();

    if (error.response && error.response.status === 404) {
      window.location = "/404";
    }
    return Promise.reject(error);
  }
);

function setPhantomData(key, value, version) {
  const now = new Date();

  const item = {
    value: value,
    version: version,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getPhantomData(key, version) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return true;
  }
  const item = JSON.parse(itemStr);

  if (item["version"] !== version) {
    localStorage.removeItem(key);
    return true;
  }
  return false;
}

// const objApiCalls = (obj) => {
//   console.log("Refreshed Mdict", obj);
//   let d = getPhantomData(
//     obj["typ"] && obj["subTyp"] ? obj["typ"] + "_" + obj["subTyp"] : obj["typ"],
//     obj["ver"]
//   );
//   console.log(d);
//   if (d) {
//     liracrypt
//       .get(obj["url"], {
//         typ: obj["typ"],
//         subTyp: obj["subTyp"] ? obj["subTyp"] : obj["typ"],
//         includeAll: false,
//         // includeAll: obj["includeAll"] ? obj["includeAll"] : false,
//       })
//       .then((res, req) => {
//         setPhantomData(
//           obj["typ"] && obj["subTyp"]
//             ? obj["typ"] + "_" + obj["subTyp"]
//             : obj["typ"],
//           res.data.data,
//           obj["ver"]
//         );
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }
// };

// const generateMdict = (data) => {
//   data.forEach((obj, ind) => {
//     objApiCalls(obj);
//   });
// };

const genCache = (data) => {
  let mDictSubTyp = ["idame", "idict", "ijoint"];
  data.forEach((obj, index) => {
    if (obj["url"] === "/mdict") {
      let localDataNotMatch = getPhantomData(
        obj["typ"] + "_" + "idame",
        obj["ver"]
      );
      if (localDataNotMatch) {
        mDictSubTyp.forEach((sub) => {
          liracrypt
            .get(obj["url"], {
              typ: obj["typ"],
              subTyp: obj["subTyp"],
              includeAll: false,
            })
            .then((res, req) => {
              setPhantomData(obj["typ"] + "_" + sub, res.data.data, obj["ver"]);
            })
            .catch((err) => {
              console.log("Error Extract Mdict - " + obj["typ"]);
            });
        });
      }
    } else if (obj["url"] === "/cropdown") {
      let localDataNotMatch = getPhantomData(obj["typ"], obj["ver"]);
      if (localDataNotMatch) {
        liracrypt
          .get(obj["url"], { name: obj["typ"], includeAll: false })
          .then((res, req) => {
            setPhantomData(obj["typ"], res.data.data, obj["ver"]);
          })
          .catch((err) => {
            console.log("Error Extract Mdict - " + obj["typ"]);
          });
      }
    }
  });
};

const hitApi = () => {

  liracrypt
    .get("/mdict", { typ: "MDictVersionControl", subTyp: "listData" })
    // .get("/textapi", { apiName: "dropCache" })
    .then((res, req) => {
      const List = res.data.data[0].listData;

      genCache(List);
      // generateMdict(res.data.data);
    })
    .catch((err) => {
      console.log(err);
    });

  setInterval(() => {
    liracrypt
      .get("/mdict", { typ: "MDictVersionControl", subTyp: "listData" })
      // .get("/textapi", { apiName: "dropCache" })
      .then((res, req) => {
        const List = res.data.data[0].listData;

        genCache(List);
        // generateMdict(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, 12000000);
};

const objPageCalls = (obj) => {
  // console.log("Refreshed Page", obj);
  let d = getPhantomData(obj["dictName"], obj["version"]);

  if (d) {
    liracrypt
      .get(obj["url"], {
        dictName: obj["dictName"],
      })
      .then((res, req) => {
        setPhantomData(obj["dictName"], res.data, obj["version"]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

const generatePage = (data) => {
  data.forEach((obj, ind) => {
    objPageCalls(obj);
  });
};

const genPageCache = (data) => {
  data.forEach((obj, index) => {
    if (obj["url"] === "/pageconfig") {
      let localDataNotMatch = getPhantomData(obj["typ"] + "Page", obj["ver"]);
      if (localDataNotMatch) {
        liracrypt
          .get("/miscellaneous/pageconfig", {
            dictName: obj["typ"],
          })
          .then((res, req) => {
            // console.log(res.data)
            setPhantomData(obj["typ"] + "Page", res.data, obj["ver"]);
          })
          .catch((err) => {
            console.log("Error Extract Mdict - " + obj["typ"] + "Page");
          });
      }
    }
  });
};

const hitPage = () => {
  liracrypt
    .get("/mdict", { typ: "PageConfigVersionControl", subTyp: "listData" })
    .then((res, req) => {

      const List = res.data.data;
      genPageCache(List);
      // generatePage(res.data.data);
    })
    .catch((err) => {

    });

  setInterval(() => {
    liracrypt
      .get("/mdict", { typ: "PageConfigVersionControl", subTyp: "listData" })
      .then((res, req) => {

        const List = res.data.data;
        genPageCache(List);
        // generatePage(res.data.data);
      })
      .catch((err) => {

      });
  }, 600000);
};

//qqq
const liracrypt = {
  axInstance: axios_v1,
  login: function (
    data,
    dispatch,
    history,
    setshowLoading,
    setInvalid,
    setErrorText,
    setResetPwd
  ) {
    setInvalid(false);

    const en_data = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      process.env.REACT_APP_SECRET_KEY
    ).toString();

    let enc_data = {
      username: Buffer.from(data["username"]).toString("base64"),
      password: Buffer.from(data["password"]).toString("base64"),
      urlCode: Buffer.from(data["urlCode"]).toString("base64"),
      scode: Buffer.from(data["scode"]).toString("base64"),
      sparsh: Buffer.from(data["sparsh"]).toString("base64"),
      encryptedData: en_data
    };

    const d = liracrypt.post("/login", enc_data);
    d.then(res => {
      if (res.data?.isSuccess) {
        const token = res.data.data.token;
        const role = res.data.data.role;
        const landingPage = res.data.data.landingPage ? `/v02/${res.data.urlCode}` + res.data.data.landingPage : null;
        const homePage = res.data.data.homePage ? `/v02/${res.data.urlCode}` + res.data.data.homePage : null;
        localStorage.setItem('homePage', homePage);

        const firstName = res.data.data.firstName;
        localStorage.setItem("token", token);
        if (res.data.resetPwd) {
          setshowLoading(false);
          setResetPwd(true);
          return;
        }
        localStorage.setItem("bgColor", (res.data.backgroundColor || '#000000'));
        if (res.data.corpLogo) {
          localStorage.setItem("corpLogo", res.data.corpLogo);
        }
        if (res.data.corpLogo2) {
          localStorage.setItem("corpLogo2", res.data.corpLogo2);
        }
        localStorage.setItem('urlCode', res.data.urlCode);
        localStorage.setItem('pKey', res.data.pKey);
        localStorage.setItem("route", window.location.search);
        // liracrypt.axInstance = baseURL;
        dispatch({
          type: 'urlCode',
          payload: res.data.urlCode
        })

        liracrypt
          .get("v04/sidebar/menu", { urlCode: res.data.urlCode })
          .then((res, req) => {

            const menus = res.data.data.map((obj, index) => {
              let menu = { ...obj };
              delete menu["SubMenu"];
              if (
                obj.SubMenu &&
                Array.isArray(obj.SubMenu) &&
                obj.SubMenu.length > 0
              ) {
                const subMenu = obj.SubMenu.map((sub, i) => {
                  return { ...sub, id: sub["Link"] + i };
                });

                menu["SubMenu"] = subMenu;
              }
              menu["id"] = menu["Link"] + index;
              return menu;
            });
            // localStorage.setItem("side", { menu: menus });
            // dispatch({ type: "SET_SIDEBAR", payload: menus });
            dispatch({
              type: "LOGIN_SUCCESS",
              payload: {
                token: token,
                user: "username",
                role: role,
                menu: menus,
              },
            });
            // hitApi();
            // hitPage();
            localStorage.setItem("uname", firstName ? firstName : "User");
            if (window.innerWidth > 700) {
              history.replace(landingPage ? landingPage : `/v02/${res.data.urlCode}/dashboard`, '');
              // history.push(landingPage);
            } else {
              history.replace(landingPage ? landingPage : `/v02/${res.data.urlCode}/dashboard`, '');
              // history.push("v02/mrpl/lineattendance");
            }
            setshowLoading(false);
            setInvalid(false);
          })
          .catch((err) => {
            console.log(err);
            setshowLoading(false);
            setInvalid(false);
          });
      } else {
        setErrorText(res.data?.message || "Invalid Login Credentials !");
        setInvalid(true);
        setshowLoading(false);
      }
    }).catch((err) => {
      console.log(err);
      if (err.response) {
        let message = err.response?.data?.message;
        console.log(message);
        if (err.response.status == 403) {
          setErrorText(message || "Username Blocked");
        } else if (err.response.status == 401) {
          setErrorText(message || "Invalid Login Credentials !");
        } else {
          setErrorText(message || "Oops !.. Something's Wrong.");
        }
      }
      // setErrorText("Oops !.. Something's Wrong.");
      setInvalid(true);
      setshowLoading(false);
    });
  },
  logout: function (history, dispatch, setLoading, loginRoute) {
    const d = liracrypt.delete("/logout", {});
    let urlCode = localStorage.getItem('urlCode');
    d.then((res, req) => {
      // localStorage.clear();
      dispatch({
        type: "LOGOUT",
      });

      history.replace(loginRoute, '');
      if (setLoading) {
        setLoading(false);
      }
    }).catch((err) => {
      console.log(err);
      // localStorage.clear();
      dispatch({
        type: "LOGOUT",
      });

      history.replace(loginRoute, '');

      if (setLoading) {
        setLoading(false);
      }
    });
    localStorage.clear();
    localStorage.setItem('urlCode', urlCode);
    liracrypt.axInstance = axios_v1;
  },
  get: async function (url, data) {
    data["token"] = localStorage ? localStorage.getItem("token") : null;
    data["urlCode"] = data.urlCode ? data.urlCode : getUrlCode();
    data["pKey"] = data.pKey ? data.pKey : localStorage.getItem('pKey');
    const response = await liracrypt.axInstance.get(url, { params: data });
    if (response?.data?.isSuccess) {
      return response;
    } else {
      if (response.data?.action === 'logout_withApi') {
        liracrypt.delete('/logout', {}).then(response => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          return;
          setTimeout(() => {
            window.location.href = `/v02/${getUrlCode()}/login`;
          }, 500);
          return;
        }).catch(err => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          console.log(err);
        })
      } else if (response.data?.action === 'logout_direct') {
        store.dispatch({
          type: 'LOGOUT'
        });
        localStorage.clear();
        return;
      } else {
        return response;
      }
      // if (response?.data?.redirectToLoginPage) {
      //   let urlCode = getUrlCode();
      //   localStorage.clear();
      //   document.location.href = `/v02/${urlCode}/login`
      // } else {
      //   return response;
      // }
    }
  },
  post: async function (url, data, params = {}) {
    // store.dispatch({
    //   type: 'apiLoading',
    //   payload: true
    // });
    const encrypt_data = data;
    const response = await liracrypt.axInstance.post(
      url,
      { data: encrypt_data },
      {
        params: {
          ...params,
          token: localStorage.getItem("token"),
          urlCode: getUrlCode(),
          pKey: localStorage.getItem('pKey'),
        }
      }
    );
    store.dispatch({
      type: 'apiLoading',
      payload: false
    });
    if (response.data.isSuccess) {
      return response;
    } else {
      if (response.data?.action === 'logout_withApi') {
        liracrypt.delete('/logout', {}).then(response => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          return;
          setTimeout(() => {
            window.location.href = `/v02/${getUrlCode()}/login`;
          }, 500);
          return;
        }).catch(err => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          console.log(err);
        })
      } else if (response.data?.action === 'logout_direct') {
        store.dispatch({
          type: 'LOGOUT'
        });
        localStorage.clear();
        return;
      } else {
        return response;
      }
    }
  },
  uploadFile: async function (url, data, params = {}) {
    const encrypt_data = data;
    return liracrypt.axInstance.post(
      url,
      encrypt_data,
      {
        params: {
          ...params,
          token: localStorage.getItem("token"),
          urlCode: getUrlCode(),
          pKey: localStorage.getItem('pKey'),
        }
      }
    );
  },
  delete: async function (url, data) {
    data["token"] = localStorage.getItem("token");
    data["urlCode"] = getUrlCode();
    data["pKey"] = localStorage.getItem('pKey');
    const response = await liracrypt.axInstance.delete(url, { params: data });
    if (response.data.isSuccess) {
      return response;
    } else {
      if (response.data?.action === 'logout_withApi') {
        liracrypt.delete('/logout', {}).then(response => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          return;
          setTimeout(() => {
            window.location.href = `/v02/${getUrlCode()}/login`;
          }, 500);
          return;
        }).catch(err => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          console.log(err);
        })
      } else if (response.data?.action === 'logout_direct') {
        store.dispatch({
          type: 'LOGOUT'
        });
        localStorage.clear();
        return;
      } else {
        return response;
      }
    }
  },
  patch: async function (url, data, token) {
    // store.dispatch({
    //   type: 'apiLoading',
    //   payload: true
    // });
    const encrypt_data = data;
    const response = await liracrypt.axInstance.patch(
      url,
      { data: encrypt_data },
      {
        params: {
          token: localStorage.getItem("token"),
          urlCode: getUrlCode(),
          pKey: localStorage.getItem('pKey'),
        }
      }
    );
    store.dispatch({
      type: 'apiLoading',
      payload: false
    });
    if (response.data.isSuccess) {
      return response;
    } else {
      if (response.data?.action === 'logout_withApi') {
        liracrypt.delete('/logout', {}).then(response => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          return;
          setTimeout(() => {
            window.location.href = `/v02/${getUrlCode()}/login`;
          }, 500);
          return;
        }).catch(err => {
          store.dispatch({
            type: 'LOGOUT'
          });
          localStorage.clear();
          console.log(err);
        })
      } else if (response.data?.action === 'logout_direct') {
        store.dispatch({
          type: 'LOGOUT'
        });
        localStorage.clear();
        return;
      } else {
        return response;
      }
    }
  },
  fileUploadPatch: async function (url, data, token) {
    const encrypt_data = data;
    return liracrypt.axInstance.patch(
      url,
      encrypt_data,
      {
        params: {
          token: localStorage.getItem("token"),
          urlCode: getUrlCode(),
          pKey: localStorage.getItem('pKey'),
        }
      }
    );
  },
  put: async function (url, data) {
    const encrypt_data = data;
    return liracrypt.axInstance.put(
      url,
      { data: encrypt_data },
      {
        params: {
          token: localStorage.getItem("token"),
          urlCode: getUrlCode(),
          pKey: localStorage.getItem('pKey'),
        }
      }
    );
  },
};

export default liracrypt;